export const rateItem = [
  {
    key: 'BMI',
    label: 'BMI_range',
  },
  {
    key: 'BMR',
    label: 'BMR_range',
  },
  {
    key: 'body_fat_rate',
    label: 'body_fat_rate_range',
  },
  {
    key: 'body_water_rate',
    label: 'body_water_rate_range',
  },
  {
    key: 'bone_mass',
    label: 'bone_mass_range',
  },
  {
    key: 'metabolic_age',
    label: 'metabolic_age_range',
  },
  {
    key: 'muscle_mass',
    label: 'muscle_mass_range',
  },
  {
    key: 'muscle_rate',
    label: 'muscle_rate_range',
  },
  {
    key: 'protein',
    label: 'protein_range',
  },
  {
    key: 'subcutaneous_fat',
    label: 'subcutaneous_fat_range',
  },
  {
    key: 'visceral_fat',
    label: 'visceral_fat_range',
  },
  {
    key: 'weight',
    label: 'weight_range',
  },
]

export const COLOR_RATE = {
  0: 'rate-none-color p-1',
  1: 'rate-insufficient-color p-1',
  2: 'rate-low-color p-1',
  3: 'rate-standard-color p-1',
  4: 'rate-hight-color p-1',
  5: 'rate-excess-color p-1',
  6: 'rate-sufficient-color p-1',
}
